import {Component} from "react"
import SectionTitle from "../SectionTitle"
import "./NdflStyles.css"
import DisplayScreens from "../DisplayScreens";
import ReactTooltip from "react-tooltip";
import React from 'react';
import Fade from 'react-reveal/Fade'
import Pulse from "react-reveal/Pulse";
import FancyNavigation from "../ScrollSpyPagination/PaginationNavigation";

class Ndfl extends Component {
    constructor() {
        super();
        this.image = React.createRef();
        this.clickToPlay = this.clickToPlay.bind();
        this.state = {
            images: ['./ndfl/CN_NDFL_1.svg', './ndfl/CN_NDFL_1 (1).png', './ndfl/CN_NDFL_2 (1).svg', './ndfl/CN_NDFL_2 (1).png', './ndfl/image 96.svg', './ndfl/image 96 (3).png'],
            isRetina: window.devicePixelRatio >= 2
        }
    }

    clickToPlay = () => {
        let imgs = this.image.current;
        imgs.classList.toggle("certificate-send");
    }

    render() {
        let screen1 = this.state.isRetina ? this.state.images[1] : this.state.images[0];
        let screen2 = this.state.isRetina ? this.state.images[3] : this.state.images[2];
        let screen3 = this.state.isRetina ? this.state.images[5] : this.state.images[4];
        return (
            <div id="box-3" className={"ndfl"}>
                <FancyNavigation/>
                <SectionTitle title={"Получайте справки о пособиях"}/>
                <Fade right duration={5000}>
                    <div className={"ndfl-blueline"}></div>
                </Fade>
                <div className={"ndfl-container"}>
                    <div className={"ndfl-info"}>
                        <Pulse forever={true} wait={3000}>
                            <div className={"ndfl-info-img"} data-tip="Заказать справку"
                                 // onClick={() => this.clickToPlay()}
                                >
                                <img className={"my-image"} src={process.env.PUBLIC_URL + './Play.svg'}/>
                            </div>
                        </Pulse>
                        <ReactTooltip/>
                        <div className={"ndfl-info-text"}>
                            <p className={"ndfl-info-text-p"}>Автоматическое формирование справок о выплаченных пособиях
                                и 2-НДФЛ</p>
                        </div>
                    </div>
                    <div className={"ndfl-screenshots"}>
                        <div className={"ndfl-screenshots-screen1"}>
                            <Fade delay={700}>
                                <DisplayScreens screen={screen1}/>
                            </Fade>
                        </div>
                        <div className={"ndfl-screenshots-screen2"}>
                            <Fade delay={1500}>
                                <DisplayScreens screen={screen2}/>
                            </Fade>
                        </div>
                    </div>
                </div>
                <div ref={this.image} className={"ndfl-certificate"}>
                    <Fade bottom duration={2000}>
                        <img className={'ndfl-certificate-img'} src={process.env.PUBLIC_URL + screen3}/>
                    </Fade>
                </div>
                <img className={"ndfl-gearwheel_wheel"} src={process.env.PUBLIC_URL + './ndfl/settings.svg'}/>
            </div>
        );

    }
}

export default Ndfl;